import Header from './components/Header';
import HeroSection from './components/HeroSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <RankingSection />
        <CarouselSection />
        <FeaturesSection />
        <CardsSection />
        <FaqSection />
        <CommentsSection />
        <UpdatesSection />
        <TopicsSection />
        <AboutSection />
        <IndexSection />
        <ContactSection />
        <MediaSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}